import { FilterItem } from '@ocean/types/dist/filter'
import { Card } from 'types/card'

// Event library
export enum EventLibrarySwitcher {
  Events,
  Categories,
}

export enum EventLibraryFilter {
  All,
  Scheduled,
  Vacant,
  BookedAndWaitlisted,
}

export type EventLibraryFilterItemNames = keyof EventLibraryFilterItems

export type EventLibraryFilterItem = {
  name: EventLibraryFilterItemNames
  value: FilterItem['value']
}

export type VirtualEventsListCategories = {
  categories: Card[]
  events: Card[]
  categoryName?: string
}

// My events
export enum MyEventsPeriodFilter {
  All,
  Past,
  Future,
}

export type MyEventsFilterItemNames = keyof MyEventsFilterItems

export type MyEventsFilterItem = {
  name: MyEventsFilterItemNames
  value: FilterItem['value']
}

export type MyEventsList = {
  items: Card[]
}

export type EventLibraryFilterItems = {
  filter: FilterItem
  isEventView: FilterItem
  searchText: FilterItem
}

export type MyEventsFilterItems = {
  periodFilter: FilterItem
  searchText: FilterItem
}
